// extracted by mini-css-extract-plugin
module.exports = {"root":"Dots_root__m3ijI","item":"Dots_item__vtMBP","selected":"Dots_selected__J4EYG","dark":"Dots_dark__3Xd24","light":"Dots_light__clSBm"};